module.exports = __webpack_public_path__ + "static/img/son8.fa7bb5b5.png";